// Mock data for Solid Base Builder website

export const companyInfo = {
  name: "Solid Base Builder",
  email: "steven@solidbasebuilder.com",
  phone: "(949) 555-0123",
  address: "29713 Niguel Rd Apt H",
  city: "Laguna Niguel",
  state: "CA",
  zip: "92677",
  fullAddress: "29713 Niguel Rd Apt H, Laguna Niguel CA 92677",
  description: "Premium construction company specializing in residential and commercial projects. We bring your vision to life with exceptional craftsmanship and attention to detail.",
  tagline: "Building Excellence, Creating Foundations for Life",
  yearsExperience: 15,
  projectsCompleted: 250
};

export const services = [
  {
    id: 1,
    title: "Residential Construction",
    description: "Custom homes, renovations, and residential remodeling projects built with precision and care.",
    features: [
      "Custom Home Building",
      "Home Renovations",
      "Kitchen & Bath Remodeling",
      "Home Additions",
      "Luxury Residential Projects"
    ],
    icon: "home"
  },
  {
    id: 2,
    title: "Commercial Construction",
    description: "Professional commercial building services for offices, retail spaces, and mixed-use developments.",
    features: [
      "Office Buildings",
      "Retail Spaces",
      "Mixed-Use Developments",
      "Tenant Improvements",
      "Commercial Renovations"
    ],
    icon: "building"
  },
  {
    id: 3,
    title: "Project Management",
    description: "Comprehensive project oversight ensuring timely delivery and budget compliance.",
    features: [
      "Project Planning",
      "Budget Management",
      "Timeline Coordination",
      "Quality Assurance",
      "Vendor Management"
    ],
    icon: "clipboard"
  },
  {
    id: 4,
    title: "Design & Consultation",
    description: "Expert design services and consultation to bring your vision to reality.",
    features: [
      "Architectural Design",
      "3D Visualization",
      "Material Selection",
      "Design Consultation",
      "Permit Assistance"
    ],
    icon: "pencil"
  }
];

export const projects = [
  {
    id: 1,
    title: "Modern Luxury Residences",
    category: "Residential",
    description: "High-rise residential complex featuring contemporary design and premium finishes.",
    image: "https://images.unsplash.com/photo-1615634364452-8daf3851f2f1",
    location: "Orange County, CA",
    year: 2024,
    size: "45,000 sq ft"
  },
  {
    id: 2,
    title: "Contemporary Residential Tower",
    category: "Residential",
    description: "Sleek modern residential skyscraper with innovative architectural design.",
    image: "https://images.unsplash.com/photo-1740904257914-45adcd97040a",
    location: "Los Angeles, CA",
    year: 2024,
    size: "38,000 sq ft"
  },
  {
    id: 3,
    title: "Urban Residential Complex",
    category: "Residential",
    description: "Modern residential tower featuring premium amenities and sustainable design.",
    image: "https://images.unsplash.com/photo-1740904258597-ac3105406453",
    location: "San Diego, CA",
    year: 2023,
    size: "52,000 sq ft"
  },
  {
    id: 4,
    title: "Luxury Estate Development",
    category: "Residential",
    description: "Premium residential construction showcasing exceptional craftsmanship.",
    image: "https://images.pexels.com/photos/15497599/pexels-photo-15497599.jpeg",
    location: "Newport Beach, CA",
    year: 2023,
    size: "28,000 sq ft"
  },
  {
    id: 5,
    title: "Downtown Commercial Tower",
    category: "Commercial",
    description: "Modern skyscraper with distinctive geometric facade and state-of-the-art facilities.",
    image: "https://images.unsplash.com/photo-1761115176718-8b7a6191ece3",
    location: "Los Angeles, CA",
    year: 2024,
    size: "125,000 sq ft"
  },
  {
    id: 6,
    title: "Mixed-Use Development",
    category: "Commercial",
    description: "Large-scale commercial construction project with retail and office space.",
    image: "https://images.unsplash.com/photo-1758261785728-24fc44937941",
    location: "Irvine, CA",
    year: 2024,
    size: "95,000 sq ft"
  },
  {
    id: 7,
    title: "Corporate Office Building",
    category: "Commercial",
    description: "Premium commercial building featuring modern design and sustainable construction.",
    image: "https://images.unsplash.com/photo-1767122225720-1d11b6a7f79f",
    location: "Orange County, CA",
    year: 2023,
    size: "78,000 sq ft"
  },
  {
    id: 8,
    title: "Flagship Commercial Center",
    category: "Commercial",
    description: "Iconic commercial skyscraper with premium finishes and modern amenities.",
    image: "https://images.unsplash.com/photo-1768204040341-6ea6aa4b5746",
    location: "San Diego, CA",
    year: 2023,
    size: "110,000 sq ft"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Anderson",
    role: "Homeowner",
    content: "Solid Base Builder transformed our vision into reality. Their attention to detail and professionalism exceeded our expectations. Our custom home is absolutely stunning!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Property Developer",
    content: "We've worked with many contractors, but Solid Base Builder stands out. They delivered our commercial project on time and within budget. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Robert Martinez",
    role: "Business Owner",
    content: "From design to completion, the team was professional, responsive, and committed to excellence. Our new office space is perfect for our growing business.",
    rating: 5
  }
];

export const stats = [
  { label: "Years Experience", value: "15+" },
  { label: "Projects Completed", value: "250+" },
  { label: "Happy Clients", value: "200+" },
  { label: "Team Members", value: "35+" }
];
